// extracted by mini-css-extract-plugin
export default {"energyStatisticsSwiper":"MonitorInfoSwiper_energyStatisticsSwiper__xrdyT","cardStyles":"MonitorInfoSwiper_cardStyles__XxSXL","singleCard":"MonitorInfoSwiper_singleCard__AeRhS"};